const TWSkeleton = ({
  className
}: {
  className?: string;
}) => {
  return <span className={`skeleton-box rounded ${className || ""}`} data-sentry-component="TWSkeleton" data-sentry-source-file="TWSkeleton.tsx" />;
};
export default TWSkeleton;